exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.feed-item[data-v-52f8aebe] {\n  padding: 1em;\n  width: 350px;\n}\n", ""]);

// exports
